import type { HelpFile } from '../../types/help'
import { BeneficiaryMultiSelectTestIds } from '../../../testids/BeneficiaryMultiSelectTestIds'

export const beneficiaryMultiSelectHelp: HelpFile = {
  docPage: '/docs/governance/access-requests',
  texts: {
    [BeneficiaryMultiSelectTestIds.beneficiaryChips]:
      'Selected beneficiaries — click the X on a chip to remove it, or press Backspace inside the search input to remove the last chip.',
  },
}
